<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h550_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('addEditViewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="$t('detailPage.loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogAddEditViewForm"
          :model="dialogAddEditViewForm"
          :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="用户名"
                    prop="userName"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.userName"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="密码"
                    prop="passWord"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.passWord"
                      show-password
                      :disabled="eventType!=='add'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="姓名"
                    prop="name"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.name"
                      disabled
                    >
                      <el-button
                        v-if="eventType!=='view'"
                        slot="append"
                        icon="el-icon-search"
                        @click="dialogEmployeeVisible=true"
                      />
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="电话"
                    prop="tel"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.tel"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item
                    label="所属组织"
                    prop="organization"
                  >
                    <el-select
                      v-model="dialogAddEditViewForm.organization"
                      placeholder="请选择组织"
                      style="width:100%"
                      :disabled="eventType === 'view'"
                    >
                      <el-option
                        v-for="item in organizationOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.label"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    v-if="eventType !== 'view'"
                    label="所在省区"
                    prop="provinceId"
                  >
                    <el-select
                      v-model="dialogAddEditViewForm.provinceId"
                      placeholder="请选择用户所在省区"
                      style="width:100%"
                      @change="handleProvinceChange"
                    >
                      <el-option
                        v-for="item in provinceOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-else
                    label="所在省区"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.provinceName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    v-if="eventType !== 'view'"
                    label="所在城市"
                    prop="cityId"
                  >
                    <el-select
                      v-model="dialogAddEditViewForm.cityId"
                      placeholder="请选择用户所在城市"
                      style="width:100%"
                      @change="handleCityChange"
                    >
                      <el-option
                        v-for="item in cityOptions"
                        :key="item.label"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                  <el-form-item
                    v-else
                    label="所在城市"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.cityName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="部门"
                    prop="department"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.department"
                      maxlength="32"
                      :disabled="eventType === 'view'"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    label="岗位"
                    prop="post"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.post"
                      maxlength="32"
                      :disabled="eventType === 'view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="状态">
                    <el-radio-group
                      v-model="dialogAddEditViewForm.status"
                      :disabled="eventType==='view'"
                    >
                      <el-radio :label="1">
                        正常
                      </el-radio>
                      <el-radio :label="2">
                        禁用
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="用户类型">
                    <el-radio-group
                      v-model="dialogAddEditViewForm.type"
                      :disabled="eventType==='view'"
                    >
                      <el-radio :label="1">
                        管理员
                      </el-radio>
                      <el-radio :label="2">
                        普通用户
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="人员类型">
                    <el-radio-group
                      v-model="dialogAddEditViewForm.sort"
                      :disabled="eventType==='view'"
                    >
                      <el-radio :label="1">
                        内勤
                      </el-radio>
                      <el-radio :label="2">
                        外勤
                      </el-radio>
                      <el-radio :label="3">
                        分中心
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="10">
                <el-col
                  v-if="eventType!=='view'"
                  :span="24"
                >
                  <el-form-item
                    label="角色"
                    prop="roleId"
                  >
                    <el-select
                      v-model="dialogAddEditViewForm.roleId"
                      multiple
                      placeholder="请选择角色"
                      style="width:100%"
                      @change="roleChangeFun"
                    >
                      <el-option
                        v-for="item in roleOptions"
                        :key="item.data"
                        :label="item.label"
                        :value="item.data"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col
                  v-else
                  :span="24"
                >
                  <el-form-item
                    label="角色"
                    prop="roleId"
                  >
                    <el-input
                      v-model="dialogAddEditViewForm.roleNames"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="24">
                  <el-form-item prop="remark">
                    <el-input
                      v-model="dialogAddEditViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      :disabled="eventType==='view'"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>

    <!-- 职员列表 -->
    <employee-list-dialog
      :dialog-visible.sync="dialogEmployeeVisible"
      dialog-title="职员信息"
      @selectedEmployeeFun="selectedEmployeeFun"
    />
  </div>
</template>
<script>

// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 选择职员
import employeeListDialog from './employeeListDialog'
// API
import { systemUserInitApi, systemUserSaveOrUpdateApi } from '@/api/user'
import { loadRoleListApi } from '@/api/role'
import { loadAreaDataApi } from '@/api/area'

export default {
  components: { employeeListDialog },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      loading: true,
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        userName: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        passWord: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        tel: [{ required: true, message: '请输入电话', trigger: 'blur' }],
        roleId: [{ required: true, message: '请选择角色', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        type: [{ required: true, message: '请选择用户类型', trigger: 'change' }],
        sort: [{ required: true, message: '请选择人员类型', trigger: 'change' }],
        organization: [{ required: true, message: '请选择所属组织', trigger: 'change' }],
        provinceId: [{ required: true, message: '请选择人员所在省区', trigger: 'change' }],
        cityId: [{ required: true, message: '请选择人员所在城市', trigger: 'change' }],
        department: [{ max: 32, message: '部门最多允许输入 32 个字符', trigger: 'blur' }],
        post: [{ max: 32, message: '岗位最多允许输入 32 个字符', trigger: 'blur' }],
        remark: [{ max: 128, message: '备注最多允许输入 128 个字符', trigger: 'blur' }]
      },
      roleOptions: [],
      provinceOptions: [],
      cityOptions: [],
      organizationOptions: [
        { label: '成都恒睿盛格营销策划有限公司' },
        { label: '云南中烟营销中心四川分中心' },
        { label: '云南中烟营销中心重庆分中心' },
        { label: '云南中烟营销中心西藏分中心' },
        { label: '云南中烟营销中心宁夏分中心' },
        { label: '其他' }
      ],
      dialogEmployeeVisible: false
    }
  },
  watch: {
    dialogVisible (val) {
      if (val) {
        let _this = this

        _this.loading = true
        _this.provinceOptions = []
        _this.cityOptions = []
        _this.roleOptions = []
        _this.dialogAddEditViewForm = {
          userName: '',
          passWord: '',
          name: '',
          employeeId: '',
          tel: '',
          organization: '',
          provinceId: '',
          provinceName: '',
          cityId: '',
          cityName: '',
          department: '',
          post: '',
          status: 1,
          type: 2,
          sort: 2,
          roleId: [],
          roleNames: '',
          remark: ''
        }
        if (_this.eventType !== 'view') {
          // 获取省区选项数据
          _this.loadProvinceData();
          // 获取角色选项数据
          _this.initRoleSelectData();
        }
        if (_this.eventType !== 'add') {
          _this.initUserData();
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
          _this.loading = false
        })
      }
    }
  },
  methods: {
    // 获取省区下拉选项数据
    loadProvinceData () {
      let _this = this
      loadAreaDataApi({ parentId: 1, isUserArea: 1 }).then(response => {
        response.data.forEach(item => {
          _this.provinceOptions.push({ label: item.name, value: item.id })
        })
      })
    },
    // 省区选择回调
    handleProvinceChange (val) {
      let _this = this
      _this.cityOptions = []
      if (val) {
        let selectedData = _this.provinceOptions.find((item) => {
          return item.value === val
        })
        _this.dialogAddEditViewForm.provinceName = selectedData.label
        _this.loadCityData(val)
      } else {
        _this.dialogAddEditViewForm.provinceName = ''
      }
      _this.dialogAddEditViewForm.cityName = ''
      _this.dialogAddEditViewForm.cityId = ''
    },
    // 获取城市下拉选项数据
    loadCityData (parentId) {
      let _this = this
      loadAreaDataApi({ parentId: parentId }).then(response => {
        response.data.forEach(item => {
          _this.cityOptions.push({ label: item.name, value: item.id })
        })
      })
    },
    // 城市选择回调
    handleCityChange (val) {
      let _this = this
      if (val) {
        let selectedData = _this.cityOptions.find((item) => {
          return item.value === val
        })
        _this.dialogAddEditViewForm.cityName = selectedData.label
      } else {
        _this.dialogAddEditViewForm.cityName = ''
      }
    },
    // 获取角色选项数据
    initRoleSelectData () {
      let _this = this
      loadRoleListApi().then(response => {
        let roleList = response.data || []
        if (roleList.length > 0) {
          roleList.forEach(element => {
            _this.roleOptions.push({ label: element.name, data: element.id })
          });
        }
      })
    },
    // 角色回调
    roleChangeFun (val) {
      let _this = this
      let selectedData = {}
      selectedData = _this.roleOptions.find((item) => {
        return item.data === val
      })
      _this.dialogAddEditViewForm.roleName = selectedData ? selectedData.name : ''
    },
    // 加载数据
    initUserData () {
      let _this = this
      systemUserInitApi({ id: _this.dataId }).then(res => {
        const { data } = res
        for (let key in _this.dialogAddEditViewForm) {
          if (key !== 'roleId') {
            _this.dialogAddEditViewForm[key] = data[key]
          }
        }
        let roleIdArr = data.roleIds.split(',')
        roleIdArr.forEach(item => {
          _this.dialogAddEditViewForm.roleId.push(Number(item))
        })
        _this.dialogAddEditViewForm.id = data.id
        _this.loadCityData(data.provinceId)
      })
    },
    // 选择职员回调
    selectedEmployeeFun (selectData) {
      this.dialogAddEditViewForm.employeeId = selectData.id
      this.dialogAddEditViewForm.name = selectData.name
      this.dialogAddEditViewForm.tel = selectData.phone
    },
    // 加载数据
    reloadData () {
      this.$emit('reloadData')
    },
    // 关闭弹框
    modalClose () {
      this.$emit('update:dialogVisible', false)
      this.$refs.dialogAddEditViewForm.clearValidate()
    },
    // 新增|修改保存
    handleSave () {
      let _this = this
      _this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          _this.$confirm((_this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '用户', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }).then(async () => {
            _this.loading = true
            let roleIdArr = _this.dialogAddEditViewForm.roleId
            let roleIds = ''
            let roleNames = ''
            roleIdArr.forEach(item => {
              roleIds += ',' + item
              let role = _this.roleOptions.find(roleItem => {
                return item === roleItem.data
              })
              roleNames += ',' + role.label
            })
            roleIds = roleIds.substring(1)
            roleNames = roleNames.substring(1)
            _this.dialogAddEditViewForm.roleIds = roleIds
            _this.dialogAddEditViewForm.roleNames = roleNames
            if (_this.eventType === 'add') {
              _this.addSave()
            } else {
              _this.editSave()
            }
          }).catch(() => { })
        }
      })
    },
    // 保存新增
    addSave () {
      let _this = this
      systemUserSaveOrUpdateApi(_this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          _this.$message({ message: res.message, type: 'success' })
          _this.reloadData()
          _this.modalClose()
        }
      }).catch(() => {
        _this.loading = false
      })
    },
    // 保存修改
    editSave () {
      let _this = this
      systemUserSaveOrUpdateApi(_this.dialogAddEditViewForm).then(res => {
        if (res.mark === '200') {
          _this.$message({ message: res.message, type: 'success' })
          _this.reloadData()
          _this.modalClose()
        }
      }).catch(() => {
        _this.loading = false
      })
    }
  }
}
</script>
<style lang="scss"  scoped>
</style>
